import React from "react";

import useConfigs from "hooks/useConfigs";
import useTranslation from "translations/useTranslation";
import ImageComponent from "@tiendeo/react-components/dist/objects/Image/Image";

import { LegalContainer, LegalImgLink, Text, DefaultLink, Pipe } from "./Footer.styles";

const PureImageComponent = React.memo(ImageComponent);

function FooterLegalInfo() {
    const t = useTranslation();
    const {
        path_privacy_legal,
        path_terms_conditions,
        static_url_assets,
        country_code,
        url_tiendeo,
    } = useConfigs();

    const badgeImage = `${static_url_assets}images/coneutralwebsite.png`;
    const badgeURL = "https://tree-nation.com/profile/impact/tiendeo#co2";
    const cookiePolicyUrl = `${url_tiendeo}/cookie-policy`;

    function handleConsentPreferences() {
        if (typeof window === "undefined" || !window.OneTrust) return;
        window.OneTrust.ToggleInfoDisplay();
    }

    return (
        <LegalContainer>
            {country_code === "ES" && (
                <LegalImgLink
                    title={t("NEUTRAL_BADGE_TITLE")}
                    href={badgeURL}
                    target="_blank"
                    rel="noreferrer"
                >
                    <PureImageComponent
                        alt={t("NEUTRAL_BADGE_TITLE")}
                        src={badgeImage}
                        threshold={100}
                        useLazyLoad
                    />
                </LegalImgLink>
            )}
            <Text
                dangerouslySetInnerHTML={{ __html: t("COPYRIGHT_AND_ADDRESS") }}
                data-testid="footerAddress_block"
            />
            <DefaultLink href={path_terms_conditions} target="_blank" rel="nofollow">
                {t("TERMS_CONDITIONS")}
            </DefaultLink>
            <Pipe> | </Pipe>
            <DefaultLink
                href={path_privacy_legal}
                target="_blank"
                rel="nofollow"
                data-testid="footerLegal_link"
            >
                {t("PRIVACY_POLICY")}
            </DefaultLink>
            <Pipe> | </Pipe>
            <DefaultLink as="a" href={cookiePolicyUrl} target="_blank" rel="nofollow">
                {t("COOKIE_POLICY")}
            </DefaultLink>
            <Pipe> | </Pipe>
            <DefaultLink onClick={handleConsentPreferences}>{t("CONSENT_PREFERENCES")}</DefaultLink>
        </LegalContainer>
    );
}

export default FooterLegalInfo;
